module.exports = __webpack_public_path__ + "img/mouse_right.3fd46aa9.svg";